import React from 'react'

// COMPONENTS
import Header from './Components/Header';
import Hero from './Components/Hero';
import Aboutme from './Components/Aboutme';
import Portfolio from './Components/Portfolio';
import Contact from './Components/Contact';
import Footer from './Components/Footer';
import Skills from './Components/Skills';
import Readiness from './Components/Readiness';
import ExperienceSection from './Components/ExperienceSection';





const App = () => {
  return <>
      <Header/>

      <section id='Home' className='greyBg heroSection'>
      <Hero/>
      </section>

      <section id='About' className='whiteBg'>
         <Aboutme/>
      </section>

      <section id='Skills' className='greyBg'>
         <Skills/>
      </section>

      <section id='Projects' className='whiteBg'>
         <Portfolio/>
      </section>
{/* 
      <section id='Testimony' className='greyBg'>
         <TestimonialSection/>
      </section> */}

      <section id='Experience' className='whiteBg'>
         <ExperienceSection/>
      </section>

      <section id='Readiness' className='greyBg'>
         <Readiness/>
      </section>

      <section id='Contact' className='whiteBg'>
         <Contact/>
      </section>

      <section className='footerBg'>
      <Footer/>
      </section>
</>
}

export default App;